import { Button, ButtonProps } from 'antd';
import React from 'react';

// Bỏ 'color' khỏi ButtonProps của antd rồi khai báo lại: từ antd 5.21, Button có
// prop `color` riêng với kiểu union hẹp ('primary' | 'danger' | ...), xung đột với
// `color?: string` mà component này dùng để truyền màu chữ CSS.
interface IButtonProps extends Omit<ButtonProps, 'color'> {
  width?: number;
  height?: number;
  bgColor?: ButtonType;
  color?: string;
  text?: JSX.Element | string;
  borderRadius?: number;
  disabled?: boolean;
  fontWeight?: string;
}

export type ButtonType =
  | 'primary-green'
  | 'secondary-green'
  | 'third-green'
  | 'primary-orange'
  | 'primary-grey'
  | 'primary-red'
  | 'primary-outline-red'
  | '';

const getButtonConfig = (
  bgColor: ButtonType = '',
  disabled: boolean | undefined
): { background: string; borderColor: string; color: string } => {
  const config = {
    background: '',
    borderColor: '',
    color: 'white',
    fontWeight: '',
  };

  if (disabled) {
    config.background = '#F0E8ED';
    config.borderColor = '#F0E8ED';
    config.color = '#9A8F9E';
    return config;
  }

  // Tên màu cũ (green/orange/red) giữ nguyên để ~120 chỗ gọi không phải sửa; giá trị
  // đổi sang bộ màu app (src/theme/tokens.ts): "green" = hành động chính hồng đậm.
  switch (bgColor) {
    case 'primary-green':
    case 'secondary-green':
      config.background = '#C2337D';
      config.borderColor = '#C2337D';
      break;
    case 'third-green':
      config.background = '#FFFFFF';
      config.borderColor = '#C2337D';
      config.color = '#C2337D';
      break;
    case 'primary-orange':
      config.background = '#B45309';
      config.borderColor = '#B45309';
      break;
    case 'primary-grey':
      config.background = '#F6F0F3';
      config.borderColor = '#ECE4E9';
      config.color = '#1D1D2E';
      break;
    case 'primary-red':
      config.background = '#B42318';
      config.borderColor = '#B42318';
      break;
    case 'primary-outline-red':
      config.background = '#FFFFFF';
      config.borderColor = '#B42318';
      config.color = '#B42318';
      break;
    default:
      config.background = '#B42318';
      config.borderColor = '#B42318';
  }

  return config;
};

function CustomButton({
  width,
  height = 36,
  bgColor,
  text,
  color,
  borderRadius = 10,
  disabled,
  fontWeight = '600',
  style,
  ...rest
}: IButtonProps) {
  const { background, borderColor, color: defaultConfigColor } = getButtonConfig(bgColor, disabled);
  return (
    <Button
      {...rest}
      style={{
        background,
        borderColor,
        width,
        height,
        borderRadius,
        color: color ?? defaultConfigColor,
        fontWeight,
        ...style,
      }}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}

export default CustomButton;
